var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 580.41 612.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.69,612.51c-29.48,0-59.78-11.45-89.08-33.89-27.11-20.77-44.85-44.56-46.79-47.2-17.69-24.19-29.85-52.41-36.28-83.76-35.37,32.02-61.95,81.78-71.66,139.45L0,573.84c10.4-61.81,35.52-117.41,72.65-160.78,22.18-25.91,47.5-46.2,74.95-60.28.12-1.04.26-2.09.39-3.14,7.52-58.23,30.04-118.53,61.78-165.45,56.52-83.54,129.04-139.6,215.55-166.61C494.38-3.99,552.93-.24,574.96,1.17c2.07.13,4.64.3,5.45.31h-.16s-.02,80-.02,80c-2.96,0-6.07-.2-10.38-.48-123.19-7.89-222.05,41.91-293.83,148.01-19.25,28.46-34.59,64.61-43.17,100.83,55.95-2.74,118.29,15.27,161.07,47.58,31.96,24.14,51.02,54.27,55.12,87.12,3.57,28.59-4.57,60.56-22.34,87.69-18.46,28.2-44.79,48.17-74.13,56.23-9.82,2.7-19.8,4.04-29.89,4.04ZM225.93,410.72c2.15,25,9.18,51.21,25.47,73.49.11.16,12.61,17.02,31.17,31.15,12.94,9.85,31.92,20.62,48.81,15.98,23.22-6.38,40.75-37.12,38.29-56.88-1.34-10.75-9.85-22.54-23.96-33.19-30.59-23.11-80.54-35.76-119.77-30.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line_2.bd9f13b4cc829a565382baaa374025a4.svg";
export { ForwardRef as ReactComponent };